var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { SOURCE_CITATION_VOCABULARY } from '../../../types/api';
export var vocabularyFormConfig = {
    tabs: [
        {
            id: 'basic',
            labelKey: 'ui-czna-authorities.vocabularies.advancedEdit.tab.basic',
            fields: [
                {
                    tag: '901',
                    labelKey: 'ui-czna-authorities.vocabularies.advancedEdit.field.901',
                    subfields: [
                        {
                            code: 'a',
                            labelKey: 'ui-czna-authorities.marc.901.subfield.a',
                            required: true,
                            defaultVisible: true,
                            colSpan: 8,
                        },
                        {
                            code: 'c',
                            labelKey: 'ui-czna-authorities.marc.901.subfield.c',
                            defaultVisible: true,
                            colSpan: 4,
                        },
                    ],
                },
            ],
        },
    ],
};
/** CZNA-1662 — the value of `901 $e` that marks an electronic source (what the backend stores). */
export var ELECTRONIC_SOURCE_FLAGGED = '1';
/**
 * CZNA-1662 — the advanced pane's layout for a term of `type`. A source citation also gets
 * `$e` „Elektronický zdroj (doplnit datum citace)“: set, the 670 $a quick pick inserts the term
 * with today's citation date. It is the 901 $e the backend stores, so the MARC preview shows
 * what is saved. A select rather than a checkbox: the form renderer draws subfields as text,
 * select or picker, and the empty option is "no".
 */
export var vocabularyFormConfigFor = function (type) {
    if (type !== SOURCE_CITATION_VOCABULARY)
        return vocabularyFormConfig;
    var tab = vocabularyFormConfig.tabs[0];
    var field = tab.fields[0];
    return __assign(__assign({}, vocabularyFormConfig), { tabs: [__assign(__assign({}, tab), { fields: [__assign(__assign({}, field), { subfields: __spreadArray(__spreadArray([], field.subfields, true), [
                            {
                                code: 'e',
                                labelKey: 'ui-czna-authorities.marc.901.subfield.e',
                                inputType: 'select',
                                selectOptions: [{
                                        value: ELECTRONIC_SOURCE_FLAGGED,
                                        labelKey: 'ui-czna-authorities.vocabularies.advancedEdit.electronicSource.yes',
                                    }],
                                defaultVisible: true,
                                colSpan: 12,
                            },
                        ], false) })] })] });
};
